export default __webpack_public_path__ + "store/static/media/dynaMedex-logo.77531bfd.svg";